"use strict";
// How many containers a ticket moves, and what a freight leg therefore costs.
//
// Both the capture form and the save path need the identical answer: a preview
// that disagrees with the stored value is the defect these rules exist to fix.
// Keep this the only implementation.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MT_PER_CONTAINER = void 0;
exports.containerCount = containerCount;
exports.legTotal = legTotal;
exports.isManualTotalStale = isManualTotalStale;
/** One container carries 25 MT. The same conversion the legacy launchpad used. */
exports.MT_PER_CONTAINER = 25;
function finiteNumber(value) {
    if (typeof value === 'number' && Number.isFinite(value))
        return value;
    if (typeof value === 'string' && value !== '') {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : undefined;
    }
    return undefined;
}
/**
 * The whole number of containers a ticket moves.
 *
 * The planned-shipments count the operator entered wins, because that is the
 * real container count. Without one, fall back to the tonnage divided by the
 * container size, rounded up — cargo ships in whole containers, so a 6 MT
 * ticket moves one container, not a quarter of one.
 *
 * Returns undefined only when the ticket carries neither figure, in which case
 * there is nothing to calculate a leg total from.
 */
function containerCount(plannedShipments, quantityMt) {
    const planned = finiteNumber(plannedShipments);
    if (planned !== undefined && planned > 0)
        return Math.max(Math.ceil(planned), 1);
    const quantity = finiteNumber(quantityMt);
    if (quantity !== undefined && quantity > 0) {
        return Math.max(Math.ceil(quantity / exports.MT_PER_CONTAINER), 1);
    }
    return undefined;
}
/**
 * A freight leg's calculated total: the cost per container times the containers
 * the ticket moves. Returns undefined when either input is missing or the rate
 * is not a positive amount, so callers can tell "no total" from "a total of 0".
 */
function legTotal(costPerContainer, containers) {
    const rate = finiteNumber(costPerContainer);
    if (rate === undefined || rate <= 0)
        return undefined;
    if (containers === undefined || containers <= 0)
        return undefined;
    return Math.round(rate * containers * 100) / 100;
}
/**
 * Whether a manually-entered leg total still matches the ticket it was entered
 * against. A stored container count that differs from the ticket's current one
 * means the operator's figure predates a change to the quantity or the
 * planned-shipments count, and must be shown as out of date rather than
 * silently recalculated.
 */
function isManualTotalStale(storedContainers, currentContainers) {
    if (storedContainers === null || storedContainers === undefined)
        return false;
    if (currentContainers === undefined)
        return false;
    return storedContainers !== currentContainers;
}
//# sourceMappingURL=freight-containers.js.map